import { heroTopics, heroFeed, hotWords } from "@/mocks/trending";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      {/* 深色渐变衬底营造强对比 */}
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50"></div>

      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 lg:grid-cols-12 gap-8 px-4 md:px-6 pt-10 pb-16 md:pt-14 md:pb-24">
        {/* 左栏：文案 + 入口 */}
        <div className="lg:col-span-7 flex flex-col justify-center">
          <div className="inline-flex items-center gap-2 self-start rounded-full bg-primary-100/80 px-3 py-1.5 text-xs font-medium text-primary-700">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-flashlight-fill text-sm"></i>
            </span>
            实时热度 · 全民吃瓜第一现场
          </div>
          <h1 className="mt-6 text-4xl md:text-5xl xl:text-6xl font-black text-foreground-950 leading-[1.12] tracking-tight">
            不看不知道，
            <br className="hidden md:block" />
            今天<b className="text-primary-600">大家在刷什么</b>
          </h1>
          <p className="mt-5 max-w-xl text-base md:text-lg text-foreground-600 leading-relaxed">
            91cg热榜与排行榜，把目前关注度高的内容直接摆到前排。大家正在看的、正在讨论的都能顺位看到，按排行顺势点开，快速跟上讨论方向。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-stretch gap-3">
            <a
              href="#hotboard"
              className="whitespace-nowrap text-center bg-primary-500 text-background-50 rounded-full px-6 py-3 text-sm font-bold hover:bg-primary-600 transition-colors cursor-pointer"
            >
              看 91cg 热榜排行
            </a>
            <a
              href="#community"
              className="whitespace-nowrap text-center bg-background-50 text-foreground-800 rounded-full px-6 py-3 text-sm font-semibold border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
            >
              围观群众评论
            </a>
          </div>

          {/* 关键词能力点 */}
          <div className="mt-8 flex flex-wrap items-center gap-2">
            {heroTopics.map((t) => (
              <span
                key={t.key}
                className="inline-flex items-center gap-1.5 rounded-full bg-background-100/80 border border-background-200 px-3 py-1.5 text-xs text-foreground-600"
              >
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-check-line text-primary-500 text-xs"></i>
                </span>
                {t.word}
              </span>
            ))}
          </div>
        </div>

        {/* 右栏：对开图卡 */}
        <div className="lg:col-span-5 flex flex-col gap-4">
          <div className="relative rounded-2xl overflow-hidden shadow-sm">
            <div className="relative w-full h-56 md:h-72">
              <img
                src="https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20curious%20watching%20crowd%20gathered%20around%20a%20glowing%20trending%20leaderboard%20screen%2C%20vermillion%20amber%20and%20cream%20tones%2C%20warm%20dynamic%20composition%2C%20clean%20vector%20style%2C%20community%20energy%20and%20excitement&width=900&height=760&seq=hero-crowd-01&orientation=portrait"
                alt="91cg热门吃瓜围观现场"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-4 md:p-5 text-background-50">
                <p className="font-display text-5xl md:text-6xl leading-none text-accent-400">TOP 1</p>
                <p className="mt-1 text-sm font-semibold">今晚热议值仍在上涨，冲榜进行中</p>
              </div>
            </div>
          </div>

          {/* 右侧实时滚动小讯条 */}
          <div className="rounded-2xl border border-background-200/80 bg-background-50 overflow-hidden">
            <div className="flex items-center justify-between px-4 py-2.5 bg-background-100/60 border-b border-background-200">
              <span className="flex items-center gap-1.5 text-xs font-bold text-foreground-800">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-500 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-500"></span>
                </span>
                实况更新
              </span>
              <span className="text-xs text-foreground-400">滚动中</span>
            </div>
            <ul className="divide-y divide-background-100">
              {heroFeed.map((f) => (
                <li key={f.id} className="px-4 py-3 flex items-start gap-3 cursor-pointer hover:bg-background-50/60 transition-colors">
                  <span className="w-4 h-4 flex items-center justify-center mt-0.5 text-accent-600">
                    <i className="ri-fire-line"></i>
                  </span>
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-foreground-800 truncate">{f.title}</p>
                    <p className="text-xs text-foreground-500 mt-0.5 truncate">{f.sub}</p>
                  </div>
                  <span className="ml-auto shrink-0 text-[11px] text-foreground-400 whitespace-nowrap">{f.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* 滚动热词条 */}
      <div className="relative border-y border-background-200/80 bg-background-50">
        <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 md:px-6 py-3">
          <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-accent-500 text-background-50 px-3 py-1 text-xs font-bold">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-up-down-line"></i>
            </span>
            今日热词
          </span>
          <div className="flex min-w-0 flex-1 items-center gap-3 overflow-hidden whitespace-nowrap">
            <div className="flex items-center gap-3 animate-[marquee_30s_linear_infinite]">
              {hotWords.concat(hotWords).map((w, i) => (
                <span key={i} className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600 cursor-pointer">
                  <span className="font-display text-primary-400">{i % 10 + 1}</span>
                  {w}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <style>{`@keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </section>
  );
}